// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_19Irv6Ok3CyBMMDbut4TmW"};